import React, { useEffect, useState } from "react"
import { Card, CardBody } from "reactstrap"
import Papa from "papaparse"
import { post } from "helpers/api_helper"
import { REPORTS } from "helpers/url_helper"

const StatusUpdate = () => {
  const [csvData, setCsvData] = useState([])
  const [isUploading, setIsUploading] = useState(false)
  const [uploadedDataCount, setUploadedDataCount] = useState(0)

  // Add this function to handle CSV file upload
  const handleFileUpload = event => {
    const file = event.target.files[0]
    if (file) {
      Papa.parse(file, {
        complete: results => {
          const [headers, ...data] = results.data
          setCsvData(data)
        },
        header: false,
      })
    }
  }

  const updateData = async () => {
    if (csvData.length === 0) return

    try {
      setIsUploading(true)
      setUploadedDataCount(`Processing CSV data: 0/${csvData.length}`)
      const filteredData = csvData.filter(row => row.length > 1)
      const CHUNK_SIZE = 10
      const chunks = []

      // Split into chunks
      for (let i = 0; i < filteredData.length; i += CHUNK_SIZE) {
        chunks.push(filteredData.slice(i, i + CHUNK_SIZE))
      }

      const allResponses = []

      const tempCounts = {
        totalsfailed: 0,
        successCount: 0,
        failedRows: [],
      }

      let processedCount = 0
      for (let i = 0; i < chunks.length; i++) {
        const chunk = chunks[i]

        processedCount += chunk.length

        setUploadedDataCount(
          `Processing CSV data: ${processedCount}/${csvData.length}`
        )
        try {
          const { success, data } = await post(
            `${REPORTS}/update-status`,
            chunk
          )
          if (success) {
            allResponses.push(data) // merge data

            tempCounts.totalsfailed += data?.failedCount || 0
            tempCounts.successCount += data?.successCount || 0
            tempCounts.failedRows = [
              ...tempCounts.failedRows,
              ...data?.failedRows,
            ]

            setUploadedData(tempCounts)
          }
        } catch (err) {
          console.error(`Chunk ${i + 1} failed`, err)
        }
      }
    } catch (error) {
      showErrorAlert("Error uploading CSV data")
    } finally {
      setIsUploading(false)
    }
  }

  useEffect(() => {
    updateData()
  }, [csvData])

  return (
    <Card>
      <CardBody>
        <label>Manual Status Update</label>
        <input
          type="file"
          accept=".csv"
          onChange={handleFileUpload}
          className="form-control"
          disabled={isUploading}
          ref={input => input && !isUploading && (input.value = "")}
        />
        <span>
          Download upload format sheet (CSV){" "}
          <a href="/express_fly_update_status.csv" download>
            click here
          </a>
        </span>
        {isUploading && (
          <div className="text-center mt-2">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">{uploadedDataCount}</p>
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default StatusUpdate
